module.exports = __webpack_public_path__ + "static/daphovina_logo-519691d984c99732f64a7dd7a6a49b05.svg";